<template>
    <div :class="[props.my]" class="border-1 border-gray border-bottom"></div>
</template>

<script lang="ts" setup>

import {defineProps, withDefaults} from "vue"
import { useStore } from "vuex"
const store = useStore();

interface Props {
    my?: string
}

const props = withDefaults(defineProps<Props>(), {
    my: "my-3"
})

</script>


<style scoped>

</style>
